import Image from 'next/image';

const ImgContainer = ({ width, height, ...props }: any) => (
  <Image
    loader={({ src }) => src}
    width={`${width || 500}`}
    height={`${height || 200}`}
    {...(props || {})}
    objectFit="contain"
  />
);

export default ImgContainer;
